import React, { useEffect, useState } from 'react'

import PropTypes from 'prop-types'
import { Progress } from 'antd'
import { translate } from 'react-i18next'
import { useSelector } from 'react-redux'

import { byteToGb, RECORD_STORAGE_WARNING_PERCENT, clampPercent } from '../../helpers'

const MyRecordProgress = ({ t }) => {
  const [isCanRecord, setIsCanRecord] = useState(false)
  const myRecordsUsage = useSelector(state => state.myRecordsUsage)
  const userProfileHistory = useSelector(state => state.userProfileHistory)
  const currentPackage = userProfileHistory.currentPackage
  const { usage_in_byte, quota_in_byte, usage_percent, is_unlimit } = myRecordsUsage
  const percentUsage = clampPercent(usage_percent)
  // cap the displayed used value at the quota so it never shows more than 100% (e.g. 8.70 GB from 5.00 GB)
  const usageInByteDisplay = usage_in_byte > quota_in_byte ? quota_in_byte : usage_in_byte
  // show at least 0.1% for tiny non-zero usage so it doesn't read as 0% when records already exist
  const percentLabel = percentUsage > 0 && percentUsage < 1 ? Math.max(0.1, Math.floor(percentUsage * 10) / 10) : Math.floor(percentUsage)
  const warningPercent = RECORD_STORAGE_WARNING_PERCENT

  useEffect(() => {
    if(currentPackage.feature?.length > 0) {
      if(currentPackage.feature.indexOf('recording') !== -1) {
        setIsCanRecord(true)
      } else {
        setIsCanRecord(false)
      }
    }
    return () => {}
  }, [currentPackage])

  return (
    <>
      <h3>{t('my_record.title')}</h3>
      {
        is_unlimit ? <div>
          <Progress percent={100} showInfo={false} status='active' className="record-progress" />
          <span>{t('my_record.unlimited')}</span><br />
        </div>:
          <div>
          <Progress percent={percentUsage} showInfo={false} status={percentUsage >= warningPercent ? 'exception' : 'active' } className="record-progress" />
          {/* <span id="text-used">{t('my_record.record_used', { usedRecord: byteToGb(usage_in_byte), totalRecord: byteToGb(quota_in_byte) })}</span><br /> */}
          <div className="usage-detail">
            {isCanRecord || (!isCanRecord && percentUsage > 0) ? <div className="usage-detail-row">
              <div className="usage-used">
                <span>{t('my_record.record_used_to')} </span>
                {percentUsage >= warningPercent ? <strong className="red">{byteToGb(usageInByteDisplay)} </strong> : <span>{byteToGb(usageInByteDisplay)} </span>}
                <span>{t('my_record.record_used_from')} </span>
                {percentUsage >= warningPercent ? <strong className="red">{byteToGb(quota_in_byte)}</strong> : <span>{byteToGb(quota_in_byte)}</span>}
              </div>
              <div className={`usage-status ${percentUsage >= warningPercent ? 'red' : ''}`}>
                {percentUsage >= 100
                  ? t('my_record.storage_full_label')
                  : t('my_record.storage_percent_used', { percent: percentLabel })}
              </div>
            </div> : null}
            
            {!isCanRecord ? <span>( {t('my_record.record_package_denied')} )</span> : null}
          </div>
        </div>
      }
    </>
  )
}

MyRecordProgress.propTypes = {
  t: PropTypes.func
}

export default translate()(MyRecordProgress)
